import React from "react";
import OnOffSettingsPage from "./OnOffSettings/OnOffSettingsPage";
import DateTimePicker from "../../../../Forms/DateTimePicker";
import { Formik, Form } from 'formik';
import TextField from "../../../../Forms/TextField";
import SubmitButton from "../../../../Forms/SubmitButton";
import useAxios from "axios-hooks";
import { axiosInstance } from '../../../../../api/config';
import env from "../../../../../env";

const SiteNotificationForm = ({ notification, isLoading, addOrEdit, setSubmitResult }) => {
    const { REACT_APP_API_BASE_URI } = env;

    const [{ loadingPost, postError }, postForm] = useAxios(
        {
            url: `2019-04-16/notifications/add`,
            method: "POST",
            baseURL: REACT_APP_API_BASE_URI,
        },
        { axios: axiosInstance, manual: true }
    );

    const [{ loadingPut, putError }, putForm] = useAxios(
        {
            url: `2019-04-16/notifications/edit`,
            method: "PUT",
            baseURL: REACT_APP_API_BASE_URI,
        },
        { axios: axiosInstance, manual: true }
    );

    const mapSelected = (items, idKey, nameKey) =>
        (items || [])
            .filter(item => item.ticked)
            .map(item => ({
                value: item[idKey],
                label: nameKey ? item[nameKey] : undefined
            }));

    const mapFormValuesToNotification = (original, values) => {
        const findByLabel = (items, label) => {
            return (items || []).find(i => i.name === label);
        };

        return {
            ...original,
            title: values.internalNotificationTitle,
            header: values.header,
            notificationHTML: values.text,
            onOff: values.onOff,
            activeFrom: values.activeFrom,
            activeTo: values.activeTo,
            clients: (values.clients || []).map(c => {
                const match = findByLabel(original.clients, c.label);
                return {
                    clientId: match?.clientID ?? null,
                    name: c.label,
                    ticked: values.onOff,
                };
            }),
            coBrands: (values.coBrands || []).map(cb => {
                const match = findByLabel(original.coBrands, cb.label);
                return {
                    coBrandId: match?.coBrandId ?? null,
                    clientId: match?.clientId ?? null,
                    name: cb.label,
                    ticked: values.onOff,
                };
            }),
            coBrandTags: (values.coBrandTags || []).map(tag => {
                const match = findByLabel(original.coBrandTags, tag.label);
                return {
                    coBrandTagId: match?.coBrandTagID ?? null,
                    name: tag.label,
                    ticked: values.onOff,
                };
            }),
        };
    };

    return (
        <div className="content-wrapper" style={{ minHeight: '100%' }}>
            <Formik
                enableReinitialize
                initialValues={{
                    activeFrom: notification.activeFrom,
                    activeTo: notification.activeTo,
                    internalNotificationTitle: notification.title ?? "",
                    header: notification.header ?? "",
                    text: notification.notificationHTML ?? "",
                    onOff: notification.onOff,
                    clients: mapSelected(notification.clients, "clientID", "name"),
                    coBrands: mapSelected(notification.coBrands, "coBrandId", "name"),
                    coBrandTags: mapSelected(notification.coBrandTags, "coBrandTagID", "name")
                }}
                onSubmit={async (values) => {
                    const updatedData = mapFormValuesToNotification(notification, values);
                    const result = addOrEdit === "add"
                        ? await postForm({ data: updatedData })
                        : await putForm({ data: updatedData });

                    setSubmitResult({
                        submitted: true,
                        successful: result.status === 200
                    });
                }}
            >
                {({ values, handleChange, setFieldValue }) => (
                    <Form>
                        <TextField
                            label="Internal Notification Title*"
                            name="internalNotificationTitle"
                            value={values.internalNotificationTitle}
                            onChange={handleChange}
                            required
                        />
                        <DateTimePicker
                            label="Active From Date"
                            name="activeFrom"
                            datetime={new Date(values.activeFrom)}
                            setDateTime={(date) => setFieldValue("activeFrom", date)}
                            required
                        />
                        <DateTimePicker
                            label="Active To Date"
                            name="activeTo"
                            datetime={new Date(values.activeTo)}
                            setDateTime={(date) => setFieldValue("activeTo", date)}
                            required
                        />
                        <TextField
                            label="Header (40 Character Max)"
                            name="header"
                            value={values.header}
                            onChange={handleChange}
                        />
                        <TextField
                            label="Text* (140 Character Max)"
                            name="text"
                            value={values.text}
                            onChange={handleChange}
                            required
                        />

                        <OnOffSettingsPage />
                        <br />
                        <SubmitButton text="Save" loading={isLoading || loadingPost || loadingPut} />
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default SiteNotificationForm;
